import { useRouter } from "next/router";
import { useSessionKf } from "components/auth/lib/useSessionKf";
import { Inbox, InboxProps, Notification } from "@novu/nextjs";
import BellSvg from "components/icons/24/notifications/bell.svg";

export default function NotificationsButton() {
  const router = useRouter();
  const { session } = useSessionKf();

  const appId = globalThis.__ENV.RUNTIME_PUBLIC_NOVU_APPLICATION_ID;
  const user: InboxProps["subscriber"] = session && {
    subscriberId: session.user.sub,
    email: session.user.name,
    firstName: session.user.given_name,
    lastName: session.user.family_name,
  };
  const appearance: InboxProps["appearance"] = {
    icons: {
      bell: Bell,
    },
    elements: {
      popoverContent: { zIndex: 20 },
      dropdownContent: { zIndex: 20 },
    },
    variables: {
      colorPrimary: "#242424",
      colorForeground: "#252525",
      fontSize: "18px",
    },
  };

  function onRouterPush(path: string) {
    router.push(path);
  }

  /**
   * Novu will not use the router for absolute urls. So we make them
   * relative if they are for this exact origin.
   */
  function onActionRedirect(redirect: Notification["redirect"]) {
    if (!redirect?.url) return;
    if (redirect.url.startsWith(location.origin))
      redirect.url = redirect.url.substring(location.origin.length);
  }

  if (!session) return null;
  return (
    <Inbox
      applicationIdentifier={appId}
      appearance={appearance}
      subscriber={user}
      localization={{
        "inbox.filters.labels.default": "Notifications", //a specific requirement
      }}
      routerPush={onRouterPush}
      onNotificationClick={(notification) =>
        onActionRedirect(notification.redirect)
      }
      onPrimaryActionClick={(notification) =>
        onActionRedirect(notification.primaryAction?.redirect)
      }
      onSecondaryActionClick={(notification) =>
        onActionRedirect(notification.secondaryAction?.redirect)
      }
    />
  );
}

function Bell() {
  return <BellSvg className="aspect-square w-full scale-150 text-gray-600" />;
}
